<section class="relative lg:py-24 py-16">
  <div class="container">
      <div class="md:flex justify-center gap-4">
          <div class="md:w-8/12">
              <div class="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                  <h5 class="text-xl font-medium mb-4">{{spec.naam}}</h5>
                  <p class="text-slate-400 omschrijving" [innerHTML]="spec?.omschrijving | mdtohtml"></p>
              </div>
          </div>
          <div class="w-full md:w-4/12 sticky">
            <img [src]="spec.pic" class="w-full border-8 border-white dark:border-slate-900 rounded-md shadow dark:shadow-gray-700" alt="">

            <div *ngIf="infoboxes.length > 0">
              <h3 class="my-6 text-xl font-semibold">Iets voor jou?</h3>
              <app-infobox-card *ngFor="let box of infoboxes" [infobox]="box"></app-infobox-card>
            </div>
          </div>
      </div>
  </div>
</section>
